import React from "react";

const FormCard = ({ title, subtitle, icon, children }) => (
  <div className="form-card">
    {title && (
      <div className="form-card-header">
        {icon && <div className="form-card-icon">{icon}</div>}
        <div>
          <span className="form-card-title">{title}</span>
          {subtitle && <span className="form-card-subtitle">{subtitle}</span>}
        </div>
      </div>
    )}
    <div className="form-card-body">{children}</div>
  </div>
);

export default FormCard;
